// extracted by css-extract-rspack-plugin
export default {"toggle":"ToggleSwitch-module__toggle","disabled":"ToggleSwitch-module__disabled","checked":"ToggleSwitch-module__checked","slider":"ToggleSwitch-module__slider"};